import type { MutatieResponse } from '@/queries/mutaties/useMutaties';

export const isMutatieSucces = (mutatieResponse?: MutatieResponse): boolean => {
  return mutatieResponse?.status === 'SUCCES';
};

export const getMutatieErrorMessage = (mutatieResponse?: MutatieResponse): string | undefined => {
  return mutatieResponse?.errorMessage ?? undefined;
};
